import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Service } from '@/infra/services/bera';

export interface UpdateBeraReportParams {
	id: string;
	organization_id: string;
	company_id: string;
	severity?: number;
	exposure?: number;
	vulnerability?: number;
	rpn?: number;
	step?: number;
	operator_evaluated?: string;
	work_center?: string;
	comment?: string | null;
	evaluator_id?: string;
	consolidated?: boolean;
	task_time?: number;
	task_time_format?: 'minutes' | 'seconds';
	has_known_injury?: boolean;
	collection_date?: Date;
	task_id?: string;
	file_id?: string;
	sector_id?: string;
	workstation_id?: string;
	bera_job_summary_id?: string;
}

export type UpdateBeraReportResponse = {
	bera_job_summary_id: string;
	collection_date: Date;
	comment: string | null;
	consolidated: boolean;
	created_at: Date;
	cycle_time: number | null;
	deleted_at: Date | null;
	evaluator_id: string;
	exposure: number;
	file_id: string;
	has_known_injury: boolean;
	id: string;
	operator_evaluate: string;
	operator_evaluated: string;
	rpn: number;
	severity: number;
	step: number;
	task_id: string;
	task_time: number;
	task_time_format: 'minutes' | 'seconds';
	updated_at: Date;
	vulnerability: number;
	work_center: string;
};

export const useUpdateBeraReport = () => {
	return useMutation<UpdateBeraReportResponse, AxiosError<Response>, UpdateBeraReportParams>(
		(params: UpdateBeraReportParams) => Service.updateReport(params),
		{
			onError: (err: any) => {
				const typeError = err.response.data.details[0]?.split('" ') ?? err;
				notification.error({
					message: I18n.get('Ops... something happened!'),
					description: I18n.get(typeError[1])
				});
			}
		}
	);
};
